import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useContext } from 'react';
import { NotificacionContext } from '../context/notificacion_context';
import { services } from '../services/api';
import { GlobalContext } from "../context/global_context";
// import { Box, Modal } from '@mui/material';
import LoaderComponent from '../components/admin/LoaderComponent';

const Dashboard = () => {

  // const style3 = {
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
  //   width: 1200,
  //   bgcolor: 'background.paper',
  //   border: '2px solid #661d40',

  //   boxShadow: 24,
  //   p: 4,
  //   display: "flex",
  //   flexDirection: "column",
  //   overflow: "hidden",
  //   overflowY: "scroll",
  //   height: "90%",
  //   borderRadius: "40px",
  // };

  const goTo = useNavigate();
  const { showNotification } = useContext(NotificacionContext)
  const [loader, setLoader] = useState({
    loading: true
  });
  const [state, setState] = useState({
    estados: [],
    openDocumento: false
  });

  // const handleCloseDocumento = () => {
  //   setState({ ...state, openDocumento: false });
  // }

  const { setFiltro, setFiltro2, setAcuse, setFiltroLeida, setDashboard } = useContext(GlobalContext)

  const dashboardStatus = async () => {
    setLoader({ ...loader, loading: true })
    let response = await services({ method: 'GET', service: `countApplications`, body: null });
    if (response.status === 200) {
      setLoader({ ...loader, loading: false })
      setState({ ...state, estados: response.data })
    } else {
      setLoader({ ...loader, loading: false })
      showNotification('error', 'Ups...', 'Ocurrio algo al cargar la información', null, 4);
    }
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      dashboardStatus();
      setAcuse('');
      setFiltro('');
      setFiltro2('');
      setFiltroLeida('');
    }

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {loader.loading &&
        <LoaderComponent />
      }
      <div id="home" className='home'>
        <div className="container text-center ">
          <div className="d-block justify-content-center">
            <div className="d-flex justify-content-between pt-3">
              <h2 className="mt-4 text-center text-large text-primary text-bolder">
                Bienvenido al Sistema para el Seguimiento de la Atención a Victimas
              </h2>

              <div className="d-block justify-content-center text-center">
                <h6 className="ms-2 mt-4 text-end text-large text-primary text-bolder">
                  Usuario: {localStorage.nombre}
                </h6>
                <h6 className="ms-2 mt-4 text-end text-large text-primary text-bolder">
                  Area: {localStorage.dependencia}
                </h6>
              </div>
            </div>

            <div>
              <h3 className="mt-4 text-center text-large text-primary text-bolder">
                N° Expedientes: {state.estados.total_solicitudes}
              </h3>
            </div>

            <div className="mt-3 mb-3 row row-cols-1 row-cols-md-4 g-4 justify-content-center">

              <div className='col'>
                <div className="card card--rounded cursor-pointer" style={{
                  backgroundColor: '#dc3545'
                }} onClick={() => {
                  // setFiltro('NO CORRESPONDE')
                  // setDashboard(5)
                  goTo("/solicitudesVictimas?status_group=sin_atender")
                }}>
                  <div className="card-body">
                    <h4 className="card-title text-bolder text-white mb-2">Sin Atender</h4>
                    <p className=" text-medium  text-bold text-white mb-1">Cantidad:{state.estados.sin_atender}</p>

                  </div>
                </div>
              </div>

              <div className='col'>
                <div className="card card--rounded  cursor-pointer" onClick={() => {
                  setDashboard(1);
                  // setFiltro('TURNADA');
                  // setFiltroLeida('LEIDA');
                  goTo("/solicitudesVictimas?status_group=sin_revim")
                }}>
                  <div className="card-body">
                    <h4 className="card-title text-bolder text-morado mb-2">Sin REVIM</h4>
                    <p className=" text-medium  text-bold text-morado mb-1">Cantidad:{state.estados.sin_revim}</p>

                  </div>
                </div>
              </div>
            </div>

            <div className="mt-3 mb-3 row row-cols-1 row-cols-md-4 g-4 justify-content-center">
              <div className='col'>
                <div className="card card--rounded cursor-pointer" onClick={() => { 
                  // setFiltro('EN TRAMITE'); 
                  // setDashboard(8); 
                  goTo("/solicitudesVictimas?status_group=sin_renavi") 
                }}>
                  <div className="card-body">
                    <h4 className="card-title text-bolder text-morado mb-2">Sin RENAVI</h4>
                    <p className="text-medium  text-bold text-morado mb-1">Cantidad:{state.estados.sin_renavi}</p>
                  </div>
                </div>
              </div>
             
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard;
